import Form from 'antd/es/form';
import React from 'react';

import type { PipelineBlock, ZipBlockConfig } from '@mai/types';

import { EnumSelect } from './shared';

interface ZipBlockEditorProps {
  block: PipelineBlock & { type: 'zip' };
  onConfigChange: (config: ZipBlockConfig) => void;
}

export const ZipBlockEditor: React.FC<ZipBlockEditorProps> = ({
  block,
  onConfigChange,
}) => {
  const [form] = Form.useForm();

  // Initialize form with current values
  React.useEffect(() => {
    form.setFieldsValue({
      combine_strategy: block.config.combine_strategy || 'merge_objects',
    });
  }, [block.config, form]);

  const handleValuesChange = (
    _: unknown,
    allValues: Partial<ZipBlockConfig>,
  ) => {
    onConfigChange({
      ...block.config,
      combine_strategy: allValues.combine_strategy || 'merge_objects',
    });
  };

  return (
    <Form
      form={form}
      layout="vertical"
      size="small"
      onValuesChange={handleValuesChange}
    >
      <EnumSelect
        label="Combine Strategy"
        name="combine_strategy"
        options={[
          {
            value: 'merge_objects',
            label: 'Merge Objects - Combine input objects into one',
          },
          {
            value: 'create_array',
            label: 'Create Array - Pack inputs into an array',
          },
        ]}
        placeholder="merge_objects"
        help="How to combine the input data"
      />
    </Form>
  );
};
